import { render, staticRenderFns } from "./ProjectInformation.vue?vue&type=template&id=166ae7a2&scoped=true&"
import script from "./ProjectInformation.vue?vue&type=script&lang=js&"
export * from "./ProjectInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166ae7a2",
  null
  
)

export default component.exports